import React, { useState } from 'react';
import Flatpickr from 'react-flatpickr';
import { Dropdown } from 'react-bootstrap';
import 'flatpickr/dist/flatpickr.min.css';

const SORT_OPTIONS = [
    { value: 'desc', label: 'Newest First', icon: 'bi-sort-down' },
    { value: 'asc', label: 'Oldest First', icon: 'bi-sort-up' },
    { value: 'unread_first', label: 'Unread First', icon: 'bi-envelope-exclamation' },
];

function SearchBar({
    handleSearchChange,
    searchCriteria,
    handleSearchCriteriaChange,
    handleReset,
    sortOrder = 'desc',
    handleSortChange,
}) {
    const [searchTerm, setSearchTerm] = useState('');

    const handleDateChange = (selectedDate) => {
        setSearchTerm(selectedDate[0].toISOString().split('T')[0]);
    };

    const handleSearchTermChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleTxtReset = () => {
        setSearchTerm('');
        handleReset();
    };

    const handleSortSelect = (value) => {
        handleSortChange(value, searchTerm);
    };

    const activeSort = SORT_OPTIONS.find((option) => option.value === sortOrder) || SORT_OPTIONS[0];

    return (
        <div style={{ flexShrink: 0 }}>
            <div className="d-flex flex-nowrap align-items-stretch gap-2 mb-3">
                <div className="input-group input-group-sm flex-grow-1">
                    <span className="input-group-text bg-light border-end-0">
                        <i className="bi bi-search text-muted"></i>
                    </span>
                    {searchCriteria === 'date' ? (
                        <Flatpickr
                            className="form-control form-control-sm border-start-0 bg-light"
                            value={searchTerm}
                            onChange={handleDateChange}
                            placeholder="Select date..."
                            options={{
                                dateFormat: 'Y-m-d',
                                maxDate: 'today',
                                allowInput: true,
                                clickOpens: true,
                                appendTo: document.body,
                                static: false,
                            }}
                        />
                    ) : (
                        <input
                            type="text"
                            className="form-control form-control-sm border-start-0 bg-light"
                            placeholder="Search contacts..."
                            onChange={handleSearchTermChange}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleSearchChange(searchTerm);
                                }
                            }}
                            value={searchTerm}
                        />
                    )}
                    <button
                        className="btn btn-primary btn-sm text-white"
                        onClick={() => handleSearchChange(searchTerm)}
                        type="button"
                    >
                        <i className="bi bi-search text-white"></i>
                    </button>
                    {searchTerm.length > 0 && (
                        <button
                            className="btn btn-outline-secondary btn-sm"
                            onClick={handleTxtReset}
                            type="button"
                        >
                            <i className="bi bi-x-lg"></i>
                        </button>
                    )}
                </div>

                <Dropdown align="end" className="flex-shrink-0">
                    <Dropdown.Toggle
                        variant="outline-secondary"
                        size="sm"
                        id="inbox-sort-dropdown"
                        title={`Sort: ${activeSort.label}`}
                        className="d-flex align-items-center justify-content-center inbox-sort-toggle"
                        style={{ width: '32px', height: '31px', padding: 0 }}
                    >
                        <i className={`bi ${activeSort.icon}`}></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                        className="shadow-sm"
                        popperConfig={{ strategy: 'fixed' }}
                        renderOnMount
                    >
                        {SORT_OPTIONS.map((option) => (
                            <Dropdown.Item
                                key={option.value}
                                active={sortOrder === option.value}
                                onClick={() => handleSortSelect(option.value)}
                            >
                                <i className={`bi ${option.icon} me-2`}></i>
                                {option.label}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            </div>

            <style>{`
                .inbox-sort-toggle::after {
                    display: none !important;
                }
            `}</style>

            <div className="row g-2">
                <div className="col-6">
                    <div className="form-check mb-0">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="searchCriteria"
                            id="firstName"
                            value="firstName"
                            checked={searchCriteria === 'firstName'}
                            onChange={handleSearchCriteriaChange}
                        />
                        <label className="form-check-label small text-muted" htmlFor="firstName">
                            First Name
                        </label>
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-check mb-0">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="searchCriteria"
                            id="lastName"
                            value="lastName"
                            checked={searchCriteria === 'lastName'}
                            onChange={handleSearchCriteriaChange}
                        />
                        <label className="form-check-label small text-muted" htmlFor="lastName">
                            Last Name
                        </label>
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-check mb-0">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="searchCriteria"
                            id="cell"
                            value="cell"
                            checked={searchCriteria === 'cell'}
                            onChange={handleSearchCriteriaChange}
                        />
                        <label className="form-check-label small text-muted" htmlFor="cell">
                            Phone
                        </label>
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-check mb-0">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="searchCriteria"
                            id="searchDate"
                            value="date"
                            checked={searchCriteria === 'date'}
                            onChange={handleSearchCriteriaChange}
                        />
                        <label className="form-check-label small text-muted" htmlFor="searchDate">
                            Date
                        </label>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SearchBar;
